const mutationtypes = Object.freeze({
  UPDATE_COSTCENTERLISTSELECT_STATE: 'updateCostCenterListSelectState',
  UPDATE_COSTCENTERNAVIGATIONBACKBUTTON_STATE: 'updateCostCenterNavigationBackButtonState',
  UPDATE_COSTCENTERLISTTABLESEARCH_STATE: 'updateCostCenterListTableSearchState',
  UPDATE_COSTCENTERLIST_SELECTED_YEAR: 'updateCostCenteristSelectedYear',
  UPDATE_COSTCENTERLIST_SELECTED_PERIODAT: 'updateCostCenterListSelectedPeriodAt',
  UPDATE_COSTCENTERLIST_SELECTED_PERIODTO: 'updateCostCenterListSelectedPeriodTo',
  UPDATE_COSTCENTERLIST_SELECTED_FACILITY: 'updateCostCenterListSelectedFacility',
  UPDATE_COSTCENTERLIST_WITH_GENERAL_LEDGER_ACCOUNTS: 'updateCostCenterListWithGeneralLedgerAccounts'
})

export default mutationtypes
